/**
 * @description Enum for all tracked events that bring rewards. Immutable stands for the fact that these events
 * shouldn't be renamed as it might break the rewards system.
 */
export const RewardedImmutableEvents = {
  SEND_EXECUTED: "Send Executed",
  TRADE_EXECUTED: "Trade Executed",
  DEPOSIT_EXECUTED: "Deposit Executed",
  ACCOUNT_ADDED: "Account Added",
};
